<p-dialog #dialog [header]="this.isDisable==true?'Xem danh mục sản phẩm':'Sửa danh mục sản phẩm'"
  [(visible)]="isShow" [modal]="true" [styleClass]="'ag-modal force-full-width'" [style]="{'width': '1200px'}"
  closeIcon="ci ci-close" maximizeIcon="ci ci-maximize" minimizeIcon="ci ci-minimize" [maximizable]="true"
  [autoZIndex]="true">
  <div class="col-12 md:col-12">
    <form #formElement [formGroup]="formGroup">
      <div class="col-12 md:col-12">
        <validation-summary #validationSummary [formElement]="formElement" [formGroup]="formGroup">
        </validation-summary>
      </div>

      <div class="col-12 md:col-12 p-fluid p-formgrid grid">
        <div class="field col-12 md:col-6">
          <label for="businessSectorCode">Lĩnh vực kinh doanh <span style="color: red;">*</span></label>
          <p-dropdown [options]="listBusinessSector" [(ngModel)]="itemDetail.businessSectorCode" (onChange)="onChangeBusinessSector()"
            formControlName="businessSectorCode" appendTo="body" [readonly]="true">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="serviceProductGroupCode">Nhóm dịch vụ sản phẩm <span style="color: red;">*</span></label>
          <p-dropdown [options]="listServiceProductService" [(ngModel)]="itemDetail.serviceProductGroupCode" [virtualScroll]="true"
            formControlName="serviceProductGroupCode" appendTo="body" [readonly]="true">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="serviceProductCode">Mã dịch vụ sản phẩm <span style="color: red;">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.serviceProductCode" formControlName="serviceProductCode" [readonly]="true">
        </div>
        <div class="field col-12 md:col-6">
          <label for="serviceProductName">Tên dịch vụ sản phẩm <span style="color: red;">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.serviceProductName" formControlName="serviceProductName" [readonly]="isDisable">
        </div>
        <div class="field col-12 md:col-6">
          <label for="measurementUnitId">Đơn vị tính <span style="color: red;">*</span></label>
          <p-dropdown [options]="listMeasurementUnit" [(ngModel)]="itemDetail.measurementUnitId" [virtualScroll]="true"
            formControlName="measurementUnitId" appendTo="body" [readonly]="isDisable">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="status">Trạng thái áp dụng <span style="color: red;">*</span></label>
          <p-dropdown [options]="listStatus" [(ngModel)]="itemDetail.status"
            formControlName="status" appendTo="body" [readonly]="isDisable">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <p-checkbox [(ngModel)]="itemDetail.hasPrice" label="Có đơn giá" formControlName="hasPrice" name="date"
            style="margin-top: 25px;" [binary]="true" [readonly]="isDisable" />
        </div>
        <div class="field col-12 md:col-6">
          <label for="unitPrice">Đơn giá <span style="color: red;">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.unitPrice" autocomplete="off" [readOnly]="!itemDetail.hasPrice"
            formControlName="unitPrice" [readonly]="isDisable">
        </div>
        <div class="field col-12 md:col-6">
          <label for="vat">VAT <span style="color: red;">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.vat" autocomplete="off"
            formControlName="vat" [readonly]="isDisable">
        </div>
        <div class="field col-12 md:col-6">
          <label for="notes">Ghi chú</label>
          <input type="text" pInputText [(ngModel)]="itemDetail.notes" autocomplete="off"
            formControlName="notes" [readonly]="isDisable">
        </div>
        <div class="field col-12 md:col-12">
          <label for="description">Mô tả dịch vụ sản phẩm <span style="color: red;">*</span></label>
          <input type="text" pInputText [(ngModel)]="itemDetail.description" autocomplete="off"
            formControlName="description" [readonly]="isDisable">
        </div>
      </div>
    </form>
  </div>
  <p-footer>
    <div class="col-12 md:col-12">
      <div class="col-8 md:col-8 fl h-text-left">
      </div>
      <div class="col-4 md:col-4 fr" *ngIf="!isDisable">
        <button pButton pRipple type="button" label="{{'BUTTON.SAVE_CLOSE' | translate}}" icon="pi pi-save"
          [disabled]="submitting" class="p-button mr-2 mb-2" (click)="saveAndClose()"></button>

        <!-- <button pButton pRipple type="button" label="{{'BUTTON.SAVE_CONTINUE' | translate}}" icon="pi pi-save"
          [disabled]="submitting" class="p-button mr-2 mb-2" (click)="save()"></button> -->
      </div>
    </div>
  </p-footer>
</p-dialog>